import { zipSync } from 'fflate';
import type { ProcessedFile } from '../types';

export class DownloadService {
  public download(file: ProcessedFile): void {
    const url = URL.createObjectURL(file.blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = file.fileName;
    anchor.click();
    URL.revokeObjectURL(url);
  }

  public async downloadArchive(files: ProcessedFile[], archiveName = 'kim-converter-results.zip'): Promise<void> {
    const entries: Record<string, Uint8Array> = {};

    for (const file of files) {
      const buffer = await file.blob.arrayBuffer();
      entries[this.getUniqueName(entries, file.fileName)] = new Uint8Array(buffer);
    }

    const archive = zipSync(entries, { level: 6 });
    this.download({
      blob: new Blob([archive], { type: 'application/zip' }),
      fileName: archiveName,
      mimeType: 'application/zip',
      size: archive.byteLength,
    });
  }

  private getUniqueName(entries: Record<string, Uint8Array>, fileName: string): string {
    if (!entries[fileName]) {
      return fileName;
    }

    const extensionIndex = fileName.lastIndexOf('.');
    const baseName = extensionIndex > 0 ? fileName.slice(0, extensionIndex) : fileName;
    const extension = extensionIndex > 0 ? fileName.slice(extensionIndex) : '';
    let index = 2;

    while (entries[`${baseName}-${index}${extension}`]) {
      index += 1;
    }

    return `${baseName}-${index}${extension}`;
  }
}
